export default "__VITE_ASSET__642564a4__"